import { Injectable } from '@angular/core';
import { AlertController, Events } from '@ionic/angular';
import { UnsavedSceneService } from './unsaved-scene.service'

import { ApiAssetService } from '../api-services/asset.api.service';
import { ApiSceneAssetRelationService } from '../api-services/scene-asset-relation.api.service';
import { AssetInScene } from '../models/AssetInScene';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  public scene;

  constructor(
    public alertController: AlertController, 
    public unsavedSceneService: UnsavedSceneService,
    public sceneAssetRelationAPIService: ApiSceneAssetRelationService,
    public assetAPIService: ApiAssetService) { }
    
  async presentActionConfirmationAlert(message, type, wasSuccessful) {

    if (!wasSuccessful) {
      message = "Something went wrong";
    }

    const alert = await this.alertController.create({
      header: type + ' confirmation',
      message: message,
      buttons: ['OK']
    });
    await alert.present();
  }

}
